import StackedBarChart from "./StackedBarChart";
export default StackedBarChart;
